/**
 * Convert datetime-local (naive local time) to ISO 8601 UTC string.
 *
 * Example:
 *   Input (user enters locally): "2024-05-09T20:00" (20:00 in UTC+2)
 *   Output: "2024-05-09T18:00:00.000Z" (18:00 UTC)
 *
 * @param {string} localDatetimeString ISO 8601 datetime-local string (e.g. "2024-05-09T20:00")
 * @returns {string|null} ISO 8601 UTC string, or null if invalid/empty
 */
export const convertLocalDatetimeToUtcIso = (localDatetimeString) => {
    if (!localDatetimeString) return null
    const localDate = new Date(localDatetimeString)
    if (Number.isNaN(localDate.getTime())) return null
    return localDate.toISOString()
}